import React from 'react';
import $ from "jquery";

import Title from '../../title';
import Server from '../../../functions/server';
import AddMaster from './AddEditMaster';
import ViewService from './ViewService';

export default class ServiceType extends React.Component {

  state = {
    data: []
  }

  componentDidMount() {
    this.getServiceMaster();
  }

  getServiceMaster = () => {
    let context = this;
    $.ajax({
      type: 'GET',
      url: Server()+'machine/ServiceType/GetMaster.php',
      success: function(data) {
          console.log(data);
          console.log('datatatat');
          try {
              data = JSON.parse(data);
              data.map((c) => {
                c.status = Number(c.status);
              })
              context.setState({ data, load: false })
          } catch (error) {
              alert('Try Agian!!!');
              context.setState({ load: false })
          }
      },
      error: function(e) {
          alert('Try again!!')
      }
  });
  }

  render() {
    let { data } = this.state;
    let i = 1;
    return (
      <div>
        <Title title='Service Type' openDrawer={this.props.openDrawer}/>
        <div style={{margin: '0.5%'}}>
          <AddMaster refresh={this.getServiceMaster} /><br/>
          <table id="table" width="100%">
            <tr id="th">
                <th>Sino</th>
                <th>Machine Name</th>
                <th>Description</th>
                <th>Status</th>
                <th>View Service</th>
                <th>Action</th>
            </tr>
            {
              data.map((c) => {
                return (
                  <tr>
                    <td>{i++}</td>
                    <td>{c.machine}</td>
                    <td>{c.name}</td>
                    <td>{c.status == 1 || c.status == '1' ? 'Active' : 'InActive'}</td>
                    <td><ViewService item={c} /></td>
                    <td>
                      <center>
                        <AddMaster item={c} refresh={this.getServiceMaster} />
                      </center>
                    </td>
                  </tr>
                )
              })
            }
          </table>
        </div>
      </div>
    );
  }

}